import { RootState } from "../store";

/**
 * Selectors for Dashboard Analytics
 */

export const selectAnalytics = (state: RootState) =>
  state.dashboardAnalytics.analytics;

export const selectAnalyticsLoading = (state: RootState) =>
  state.dashboardAnalytics.loading;

export const selectAnalyticsError = (state: RootState) =>
  state.dashboardAnalytics.error;

export const selectAnalyticsLastFetched = (state: RootState) =>
  state.dashboardAnalytics.lastFetched;

/**
 * Check if analytics data exists in cache
 */
export const selectHasAnalyticsCache = (state: RootState) =>
  state.dashboardAnalytics.analytics !== null;

/**
 * Select current time range filter
 */
export const selectTimeRange = (state: RootState) =>
  state.dashboardAnalytics.timeRange;
